export default __webpack_public_path__ + "static/media/rr3.5825fb17.jpg";